(function(){
  'use strict';

  // AJAX add to cart
  document.body.addEventListener('submit', async function(e){
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      var fd = new FormData(form);
      var r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      if (!r.ok) throw new Error('Add failed');
      var cart = await fetch('/cart.js').then(function(x){ return x.json(); });
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
      if (btn) { btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = original; btn.disabled = false; }, 1400); }
    } catch (err) {
      if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
    }
  });

  // Variant select sync on PDP
  document.querySelectorAll('.pdp__form').forEach(function(form){
    var variantSelect = form.querySelector('select[name="id"]');
    var optionSelects = form.querySelectorAll('select[data-option-index]');
    if (!variantSelect || !optionSelects.length) return;
    optionSelects.forEach(function(sel){ sel.addEventListener('change', function(){
      var values = Array.from(optionSelects).map(function(s){ return s.value; });
      Array.from(variantSelect.options).forEach(function(opt){
        if (opt.dataset.options === values.join('|')) {
          variantSelect.value = opt.value;
        }
      });
    }); });
  });
})();
